export default function findTooltips() {
    const tooltips = document.querySelectorAll('.spv-help');
    const tooltipButtons = document.querySelectorAll('.spv-help__button');
    const tooltipContents = document.querySelectorAll('.spv-help__content');
    tooltipButtons.forEach(function (toggleButton, index) {
        const tooltip = tooltips[index];
        const tooltipContent = tooltipContents[index];
        toggleButton.addEventListener('click', function () {
            function HelpTextOpen() {
                tooltip.classList.remove('spv-help--expanded');
                toggleButton.setAttribute('aria-expanded', 'false');
                tooltipContent.setAttribute('aria-hidden', 'true');
                toggleButton.querySelector('.spv-help__openText')?.setAttribute('aria-hidden', 'false');
                toggleButton.querySelector('.spv-help__closeText')?.setAttribute('aria-hidden', 'true');
            }
            function HelpTextClose() {
                tooltip.className += ' spv-help--expanded';
                toggleButton.setAttribute('aria-expanded', 'true');
                toggleButton.querySelector('.spv-help__openText')?.setAttribute('aria-hidden', 'true');
                toggleButton.querySelector('.spv-help__closeText')?.setAttribute('aria-hidden', 'false');
                tooltipContent.setAttribute('aria-hidden', 'false');
            }
            if (tooltip?.classList.contains('spv-help--expanded')) {
                HelpTextOpen();
            }
            else {
                HelpTextClose();
            }
        });
    });
}
findTooltips();
//# sourceMappingURL=help.js.map